import { useQuery, useMutation } from '@tanstack/react-query'
import {
  validateVacancySuggestionToken,
  respondToVacancySuggestion,
} from '../infrastructure/vacancy-suggestion-response-service'
import type { VacancySuggestionRespondRequest } from '../dto/vacancySuggestionDto'

export function useVacancySuggestionToken(token: string | undefined) {
  return useQuery({
    queryKey: ['vacancySuggestionToken', token],
    queryFn: () => validateVacancySuggestionToken(token!),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}

export function useRespondToVacancySuggestion() {
  return useMutation({
    mutationFn: (request: VacancySuggestionRespondRequest) =>
      respondToVacancySuggestion(request),
  })
}
